class UploadCPEController {
    constructor($scope, $http, $window, $timeout) {
        'ngInject';
        this.$scope = $scope;
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.spinner = true;
        this.httpError = false;

        this.fileUploaded = false;

        // Final Upload Statuses
        this.success = false;
        this.error = false;
        this.modalSuccess = false;
        this.modalError = false;

        // Selectors
        this.overlayID = '#loadingOverlay';
        this.fileUploadFormID = '#uploadForm';
        this.fileUploadInputID = '#fileUploadInput';

        // Default Values
        this.errorMsg = '';
        this.fileName = '[File Name].XLSX';
    }

    triggerClientUpload() {
        this.success = false;
        this.error = false;
        this.modalSuccess = false;
        this.modalError = false;
        $(this.fileUploadInputID).trigger('click');
    }

    displayFileName() {
        this.fileName = $(this.fileUploadInputID).get(0).files[0].name;
        this.fileUploaded = true;
        this.$scope.$apply();
    }

    uploadFile() {
        if(window.FormData !== undefined) {
            // Initialization
            this.spinner = true;
            this.success = false;
            this.error = false;
            this.modalSuccess = false;
            this.modalError = false;
            $(this.overlayID).overlay();

            // Fetch uploaded file
            var file = $(this.fileUploadInputID).get(0).files[0];

            /* eslint-disable */
            var fileData = new FormData();
            /* eslint-enable */
            fileData.append(file.name, file);
            fileData.append('validColumns', this.validColumns);
            fileData.append('rowThreshold', this.rowThreshold);
            fileData.append('dateFormat', this.dateFormat);
            fileData.append('eventStartDateRange', this.eventStartDateRange);
            fileData.append('qualifyingActivity', this.qualifyingActivity);
            fileData.append('methodofDelivery', this.methodofDelivery);
            fileData.append('iSACAMemberNumberDigits', this.isacaMemberNumberDigits);
            fileData.append('cpeHours', this.cpeHours);
            this.$timeout(() => {
                this.$http({
                    url: '/api/chapterleader/UploadCPEFile',
                    method: 'POST',
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined
                    },
                    data: fileData
                }).then((response) => {
                    if(!response.data.ErrorStatus) {
                        this.spinner = false;
                        this.success = true;
                        this.modalSuccess = true;
                    } else {
                        if(response.data.ErrorStatus && !response.data.SuccessStatus) {
                            this.errorMsg = response.data.ErrorStatus;
                            this.spinner = false;
                            this.error = true;
                            this.modalError = true;
                        } else {
                            if(response.data.ErrorStatus && response.data.SuccessStatus) {
                                this.errorMsg = response.data.ErrorStatus;
                                this.spinner = false;
                                this.success = true;
                                this.error = true;
                                this.modalSuccess = true;
                            }
                        }
                    }
                }, (response) => {
                    this.errorMsg = response;
                    this.spinner = false;
                    this.error = true;
                    this.modalError = true;
                });
            }, 750);
        } else {
            this.errorMsg = 'Uh oh! It looks like there was an issue with selecting your file. Try selecting your file again.';
            this.error = true;
            this.modalError = true;
            this.fileUploaded = false;
        }
    }

    toggleOverlay() {
        if(this.success || this.error) {
            $(this.overlayID).overlay();
        }
    }
}

export default UploadCPEController;



// WEBPACK FOOTER //
// ./src/app/angular/upload-cpe/upload-cpe.controller.js